// src/components/PreInterviewNotes.js
//
// Ön görüşme notları — ÇİFT FORMAT okuma (K9).
// Eski kayıtlar: `notlar` tek bir string (canlıda 94/94 kayıt böyle) ve her kaydetmede
// üzerine yazılıyordu. Yeni kayıtlar: `notlar` dizisi [{metin, tarih, yazan}] — notlar
// eklenir, asla ezilmez. Migration scripti GEREKMEZ; okuma her iki formatı da anlar.
//
// DİKKAT: Firestore dizi ELEMANLARININ içinde serverTimestamp() kullanılamaz —
// bu yüzden not tarihi istemci saatiyle Timestamp.now() olarak yazılır.

import { Timestamp } from 'firebase/firestore';

// Firestore Timestamp / {seconds,nanoseconds} / ISO string / Date → Date | null
// ({seconds,...} hâli react-router state'i üzerinden geçen kayıtlarda oluşur:
//  history API structured clone yaptığı için Timestamp sınıfı düz nesneye döner.)
export const notTarihiToDate = (tarih) => {
    if (!tarih) return null;
    if (typeof tarih.toDate === 'function') return tarih.toDate();
    if (tarih instanceof Date) return isNaN(tarih.getTime()) ? null : tarih;
    if (typeof tarih === 'object') {
        const saniye = tarih.seconds ?? tarih._seconds;
        if (typeof saniye === 'number') return new Date(saniye * 1000);
        return null;
    }
    const date = new Date(tarih);
    return isNaN(date.getTime()) ? null : date;
};

// Her formatı tek şekle indirger: [{metin, tarih, yazan}] — kronolojik (en eski önce).
export const parseNotlar = (notlar) => {
    if (!notlar) return [];

    if (typeof notlar === 'string') {
        const metin = notlar.trim();
        return metin ? [{ metin, tarih: null, yazan: '' }] : [];
    }

    if (Array.isArray(notlar)) {
        return notlar
            .map(not => {
                if (typeof not === 'string') return { metin: not.trim(), tarih: null, yazan: '' };
                if (not && typeof not === 'object') {
                    return {
                        metin: (not.metin ?? not.text ?? '').toString().trim(),
                        tarih: not.tarih ?? null,
                        yazan: (not.yazan ?? '').toString()
                    };
                }
                return { metin: '', tarih: null, yazan: '' };
            })
            .filter(not => not.metin);
    }

    return [];
};

// Görüntüleme sırası: en yeni üstte. Tarihsiz (legacy) notlar en alta iner.
export const parseNotlarYeniden = (notlar) => {
    const liste = parseNotlar(notlar).map((not, index) => ({ ...not, _sira: index }));
    return liste.sort((a, b) => {
        const aDate = notTarihiToDate(a.tarih);
        const bDate = notTarihiToDate(b.tarih);
        if (aDate && bDate) return bDate - aDate;
        if (aDate) return -1;
        if (bDate) return 1;
        return b._sira - a._sira;
    });
};

// Yeni not ekler; legacy string not birinci eleman olarak KORUNUR.
export const notEkle = (mevcutNotlar, metin, yazan) => {
    const temiz = (metin || '').trim();
    if (!temiz) return parseNotlar(mevcutNotlar);
    return [
        ...parseNotlar(mevcutNotlar),
        { metin: temiz, tarih: Timestamp.now(), yazan: yazan || '' }
    ];
};

// En son yazılan notun metni (kart önizlemesi için).
export const sonNotMetni = (notlar) => {
    const liste = parseNotlarYeniden(notlar);
    return liste.length ? liste[0].metin : '';
};

export const notSayisi = (notlar) => parseNotlar(notlar).length;

// Dizi formatını düz metne indirir — randevu/iş emri notu gibi tek satırlık
// alanlara aktarırken kullanılır (o alanlar hâlâ string tutar).
export const notlarToText = (notlar) => {
    if (typeof notlar === 'string') return notlar;
    return parseNotlarYeniden(notlar)
        .map(not => {
            const date = notTarihiToDate(not.tarih);
            const etiket = date ? date.toLocaleDateString('tr-TR') : null;
            return etiket ? `[${etiket}] ${not.metin}` : not.metin;
        })
        .join('\n');
};

export const formatNotTarihi = (tarih) => {
    const date = notTarihiToDate(tarih);
    if (!date) return '';
    return date.toLocaleString('tr-TR', {
        day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
    });
};
